import Vue from 'vue'
import Router from 'vue-router'


//注册邀请
import register from '@/pages/register'
//注册实名
import autonym from '@/pages/autonym'
//企业注册
import registerJT from '@/pages/registerJT'
//企业实名
import autonymJT from '@/pages/autonymJT'
//用户协议
import useragreement from '@/pages/useragreement'
//注册成功
import registerSuccess from '@/pages/registerSuccess'

//注册邀请
import registerLkl from '@/pages/registerLkl'
//注册实名
import autonymLkl from '@/pages/autonymLkl'

//注册邀请
import registerShqd1 from '@/pages/registerShqd1'
//注册实名
import autonymShqd1 from '@/pages/autonymShqd1'

//注册邀请
import registernew from '@/pages/registernew'
//注册实名
import autonymnew from '@/pages/autonymnew'

Vue.use(Router)

export default new Router({

  routes: [
    //注册邀请
    {
      path: '/register',
      name: 'register',
      meta: { title: "注册" },
      component:register
    },
    //注册实名
    {
      path: '/autonym',
      name: 'autonym',
      meta: { title: "实名" },
      component:autonym
    },
    //企业注册
    {
      path: '/registerJT',
      name: 'registerJT',
      meta: { title: "注册" },
      component:registerJT
    },
    //企业实名
    {
      path: '/autonymJT',
      name: 'autonymJT',
      meta: { title: "实名" },
      component:autonymJT
    },

    //用户协议
    {
      path: '/useragreement',
      name: 'useragreement',
      meta: { title: "用户协议" },
      component:useragreement
    },
    //注册成功
    {
      path: '/registerSuccess',
      name: 'registerSuccess',
      meta: { title: "注册成功" },
      component:registerSuccess
    },

    //注册邀请
    {
      path: '/registerLkl',
      name: 'registerLkl',
      meta: { title: "注册" },
      component:registerLkl
    },
    //注册实名
    {
      path: '/autonymLkl',
      name: 'autonymLkl',
      meta: { title: "实名" },
      component:autonymLkl
    },
     //注册邀请
    {
      path: '/registerShqd1',
      name: 'registerShqd1',
      meta: { title: "注册" },
      component:registerShqd1
    },
    //注册实名
    {
      path: '/autonymShqd1',
      name: 'autonymShqd1',
      meta: { title: "实名" },
      component:autonymShqd1
    },
    //注册邀请
    {
      path: '/registernew',
      name: 'registernew',
      meta: { title: "注册" },
      component:registernew
    },
    //注册实名
    {
      path: '/autonymnew',
      name: 'autonymnew',
      meta: { title: "实名" },
      component:autonymnew
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js